import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, KPI, PageHeader, brl, num, dt } from "./_shared";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function AdminFinancial() {
  const [k, setK] = useState(null);
  const [growth, setGrowth] = useState({ revenue: [] });
  const [tx, setTx] = useState([]);

  useEffect(() => {
    api.get("/admin/kpis?period=30d").then(r => setK(r.data));
    api.get("/admin/growth?days=90").then(r => setGrowth(r.data));
    // reuse finance/summary of the OWNER for a quick tx table (owner sees only own)
    api.get("/finance/summary").then(r => {
      const all = [...(r.data.buckets?.paid || []), ...(r.data.buckets?.pending || []), ...(r.data.buckets?.overdue || [])];
      setTx(all.slice(0, 20));
    }).catch(()=>{});
  }, []);

  return (
    <div className="p-3 sm:p-6 lg:p-8" data-testid="admin-financial">
      <PageHeader title="Dashboard Financeiro" subtitle="Visão consolidada da receita, MRR e inadimplência"/>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <KPI label="Receita 30d" value={brl(k?.revenue?.amount_cents)} delta={k?.revenue?.delta_pct} tone="gold" testid="fin-revenue"/>
        <KPI label="MRR" value={brl(k?.revenue?.mrr_cents)} tone="purple" testid="fin-mrr"/>
        <KPI label="Assinantes ativos" value={num(k?.subscriptions?.active)} tone="green" testid="fin-subs"/>
        <KPI label="Inadimplência" value={brl(k?.collections?.overdue_amount_cents)} hint={`${num(k?.collections?.overdue_count)} pendentes`} tone="red" testid="fin-overdue"/>
      </div>

      <Card title="Evolução da receita" kicker="Últimos 90 dias" className="mb-6" testid="fin-chart">
        <div className="h-72">
          {(growth.revenue || []).filter(r => (r.amount_cents || 0) > 0).length === 0 ? (
            <div className="h-full flex items-center justify-center text-sm text-slate-500" data-testid="fin-chart-empty">
              Sem receita registrada nos últimos 90 dias
            </div>
          ) : (
            <ResponsiveContainer>
              <LineChart data={growth.revenue.map(r => ({ day: r.day, amount: (r.amount_cents || 0) / 100 }))}>
                <CartesianGrid stroke="#1e293b" strokeDasharray="3 3"/>
                <XAxis dataKey="day" stroke="#64748b" fontSize={11}/>
                <YAxis stroke="#64748b" fontSize={11}/>
                <Tooltip contentStyle={{ background: "#0f1524", border: "1px solid #1e293b", color: "#e2e8f0" }}
                  formatter={(v)=>new Intl.NumberFormat("pt-BR", { style:"currency", currency:"BRL" }).format(v)}/>
                <Line type="monotone" dataKey="amount" stroke="#d4a24c" strokeWidth={2.5} dot={false}/>
              </LineChart>
            </ResponsiveContainer>
          )}
        </div>
      </Card>

      <Card title="Últimas transações (do OWNER)" kicker="Cobranças" testid="fin-tx">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-white/5">
              <th className="py-2 pr-4">Cliente</th>
              <th className="py-2 pr-4">Data</th>
              <th className="py-2 pr-4 text-right">Valor</th>
              <th className="py-2 pr-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {tx.length === 0 && <tr><td colSpan="4" className="py-6 text-center text-slate-500">Sem cobranças ainda</td></tr>}
            {tx.map((t,i)=>(
              <tr key={i} className="border-b border-white/5">
                <td className="py-2 pr-4 text-slate-100">{t.client_name || "—"}</td>
                <td className="py-2 pr-4 text-slate-400 text-xs">{dt(t.created_at)}</td>
                <td className="py-2 pr-4 text-right text-[#d4a24c]">R$ {(t.amount || 0).toFixed(2)}</td>
                <td className="py-2 pr-4 text-slate-300">{t.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
